import { gateTone, readableGate } from "../lib/ui";
import { roleGateFocus } from "../lib/master";

export default function GateStrip({ gates, guide, compact = false }) {
  if (!gates?.length) return null;
  const focus = roleGateFocus(guide?.role);
  return (
    <div className={`gate-strip${compact ? " compact" : ""}`} data-testid="gate-strip">
      <div className="gate-strip-head">
        <p className="kicker">G1–G8 · YOUR GATE</p>
        {!compact && <small>{focus ? `${focus} is yours on this tenant` : "Gate status for the selected application"}</small>}
      </div>
      <div className="gate-strip-row">
        {gates.map((g) => (
          <div
            key={g.id}
            className={`gate-strip-item tone-${gateTone(g.state)}${g.id === focus ? " is-focus" : ""}`}
            data-testid={`gate-strip-${g.id.toLowerCase()}`}
          >
            <small>{g.id}</small>
            <strong>{readableGate(g.state)}</strong>
            <span>{g.owner || g.pending_by || "—"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
